// src/heroes/PatientHero.tsx
"use client"

import React from "react"
import patientHeroStyles from "./patientHero.module.scss"
import StyledText from "../typography/typography-component"
import Image from "next/image"
import skColors from "../../styles/skColors"
import classNames from "classnames"
import wave from "../../styles/LandingPage/Waves.module.scss"
import { CheckMark } from "../svgs/CheckMark"
import Button from "../components/Button/Button"
import { useTranslations } from "next-intl"
import { Routes, useTypedRouter } from "../data/routes"
import { FacebookEvents, sendFacebookEvent } from "../tracking/facebook/events"
import { TrackedActions } from "../tracking/trackedActions"

const PatientHero = () => {
  const router = useTypedRouter()
  const t = useTranslations("index") // use the index namespace

  return (
    <div className={patientHeroStyles.hero}>
      <Image
        className={patientHeroStyles.heroImageBigDesktop}
        alt={"hero image big desktop"}
        quality={90}
        src={"/images/hero_patient_2025-03-25/hero-desktop.webp"}
        width={4000}
        height={1648}
      />
      <Image
        quality={90}
        className={patientHeroStyles.heroImageDesktop}
        alt={"hero image desktop"}
        src={"/images/hero_patient_2025-03-25/hero-small-desktop.webp"}
        width={3840}
        height={206}
        style={{
          maxWidth: "100%",
          height: "auto",
        }}
      />
      <Image
        className={patientHeroStyles.heroImageTablet}
        alt={"hero image tablet"}
        src={"/images/hero_patient_2025-03-25/hero-tablet.webp"}
        width={1684}
        height={1390}
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "100%",
        }}
      />
      <Image
        className={patientHeroStyles.heroImagePhone}
        alt={"hero image phone"}
        src={"/images/hero_patient_2025-03-25/hero-mobile.webp"}
        width={752}
        height={992}
        style={{
          width: "100%",
          height: "auto",
          maxWidth: "100%",
        }}
      />

      <div className={patientHeroStyles.heroContent}>
        <StyledText className={patientHeroStyles.heroTitle} variant={"h1"} color={skColors.turquoise[600]}>
          {t("hero.title")}
        </StyledText>

        <ul className={classNames(patientHeroStyles.heroUlBlock)}>
          <li className={classNames(patientHeroStyles.heroUlListItem)}>
            <CheckMark style={{ marginRight: "12px" }} />
            <StyledText variant={"pRegular"}>{t("hero.subtitle")}</StyledText>
          </li>
          <li className={classNames(patientHeroStyles.heroUlListItem)}>
            <CheckMark style={{ marginRight: "12px" }} />
            <StyledText variant={"pRegular"}>{t("hero.support")}</StyledText>
          </li>
          <li className={classNames(patientHeroStyles.heroUlListItem)}>
            <CheckMark style={{ marginRight: "12px" }} />
            <StyledText variant={"pRegular"}>{t("hero.quality")}</StyledText>
          </li>
        </ul>

        <Button
          style={{
            // zIndex: 10,
            padding: "12px 40px 12px !important",
          }}
          className={patientHeroStyles.marginSmall}

          onClick={() => {
            console.log("patient heror CTA clicked")
            void TrackedActions.goToSelfCheck()
          }}
          hug
          variant={"CTA"}
        >
          <StyledText color={"white"} variant={"cta"}>
            {t("hero.cta")}
          </StyledText>
        </Button>
      </div>

      <div className={wave.heroBottomWavePatient}>
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            className={wave.shapeFill}
          ></path>
        </svg>
      </div>
    </div>
  )
}

export default PatientHero
